import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { StatusAPI } from '../../enum'
import { MissionData, MissionArrayInterface, MissionTotalInterface } from '../../models'
import { Metadata } from '../../models/common/common'

export interface GetAllPayload {
  limit: Number
  offset: Number
}

interface missionList {
  status: StatusAPI
  list: MissionData[]
  loading: boolean
  metadata: Metadata
}

interface totalMissions {
  status: StatusAPI
  number: number
  loading: boolean
}

export interface missionState {
  missionList: missionList
  totalMission: totalMissions
  error: string
}

const initialState: missionState = {
  missionList: {
    status: StatusAPI.initial,
    list: [],
    loading: false,
    metadata: {
      count: 0,
      limit: 0,
      total: 0,
    },
  },
  totalMission: {
    status: StatusAPI.initial,
    number: 0,
    loading: false,
  },
  error: '',
}

const missionSlice = createSlice({
  name: 'Mission',
  initialState,
  reducers: {
    clearList(state) {
      state.missionList = initialState.missionList
    },
    getMissionsRequest(state) {
      state.missionList.status = StatusAPI.calling
      state.missionList.loading = true
    },
    getMissionsSuccess(state, action: PayloadAction<MissionArrayInterface>) {
      state.missionList.status = StatusAPI.success
      state.missionList.list = action.payload.data.entry
      state.missionList.loading = false
      state.missionList.metadata = action.payload.data.metadata
    },
    getMissionsFailed(state, action: PayloadAction<any>) {
      state.missionList.status = StatusAPI.failure
      state.error = action.payload
      state.missionList.loading = false
    },
    clearTotalMission(state) {
      state.totalMission = initialState.totalMission
    },
    getTotalMissionRequest(state) {
      state.totalMission.status = StatusAPI.calling
      state.totalMission.loading = true
    },
    getTotalMissionSuccess(state, action: PayloadAction<MissionTotalInterface>) {
      state.totalMission.status = StatusAPI.success
      state.totalMission.number = action.payload.data.total
      state.totalMission.loading = false
    },
    getTotalMissionFailed(state, action: PayloadAction<any>) {
      state.totalMission.status = StatusAPI.failure
      state.error = action.payload
      state.totalMission.loading = false
    }
  },
})

export const {
  clearList,
  getMissionsRequest,
  getMissionsSuccess,
  getMissionsFailed,
  clearTotalMission,
  getTotalMissionRequest,
  getTotalMissionSuccess,
  getTotalMissionFailed
} = missionSlice.actions
export default missionSlice.reducer